module.exports = __webpack_public_path__ + "img/ring_y_skip_null_1@2x.2c58be4d.png";